module.exports = "/assets/be41f64fa44d5a85ac35dc639f11d4e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/B5.png
// module id = 1218
// module chunks = 0